import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BottomBar, Button } from '@salecycle/ui-component-library';
import { useImportConsentContext } from '../context/ImportConsentContext';
import { RAGStatus } from '../types';

const SpacedElement = styled.div`
  margin-right: 1rem;
`;

const BottomBarRightElement = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  margin-right: 1rem;
`;

export function BottomBarAnalysisNav() {
  const { t } = useTranslation('fileManagement');
  const { fileData, setFileData, setImportFileModalVisibility } = useImportConsentContext();

  const fileImportDisabled =
    fileData.filter(file => file.status.type !== RAGStatus.GREEN).length > 0 || fileData.length === 0;

  const discardChanges = (): void => setFileData([]);

  return (
    <BottomBar>
      <BottomBarRightElement>
        <SpacedElement>
          <Button variation="secondary" onClick={discardChanges}>
            {t('analysis.bottomBar.discard.button.text')}
          </Button>
        </SpacedElement>
        <Button variation="primary" onClick={() => setImportFileModalVisibility(true)} disabled={fileImportDisabled}>
          {t('analysis.bottomBar.import.button.text')}
        </Button>
      </BottomBarRightElement>
    </BottomBar>
  );
}
